var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSave01 = function SvgIconSave01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -5.92,
    y1: 81.76,
    x2: 55.79,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15.15,
    y1: 106.64,
    x2: 76.86,
    y2: 54.37,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.44,62.34c1.74,1.74,4.1,2.72,6.56,2.71,2.46,0,4.82-.97,6.56-2.71l19.57-19.57c1.36-1.4,1.36-3.63,0-5.03-1.39-1.44-3.68-1.48-5.12-.09l-17.38,17.38V5.61c0-2-1.62-3.62-3.62-3.62s-3.62,1.62-3.62,3.62v49.41l-17.38-17.38c-1.41-1.41-3.71-1.41-5.12,0-1.41,1.41-1.41,3.71,0,5.12l19.57,19.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.38,59.45c-2,0-3.62,1.62-3.62,3.62v25.33c0,1.3-1.06,2.36-2.36,2.36H9.61c-1.3,0-2.36-1.06-2.36-2.36v-25.33c0-2-1.62-3.62-3.62-3.62s-3.62,1.62-3.62,3.62v25.33c0,5.3,4.3,9.6,9.61,9.61h80.79c5.3,0,9.6-4.3,9.61-9.61v-25.33c0-2-1.62-3.62-3.62-3.62Z"
  })));
};
export default SvgIconSave01;